import "./_evenement.scss";

import {ReactElement} from "react";
import {evenement} from "types/evenement";

import iconLocation from "@/assets/iconLocation.svg";
import Button from "@/components/Button/Button";
import {Skeleton} from "@/components/ui/skeleton";
import {formatDate} from "@/function/formatDate";

function Evenement({evenement}: {evenement: evenement}): ReactElement | null {
  return evenement?.date ? (
    <div
      className="evenement evenement-skeleton"
      onTouchStart={function (this: HTMLDivElement) {
        this.classList.toggle("hover");
      }}>
      <div className="flipper">
        <div id="front">
          <p className="evenement-head">{formatDate(evenement.date)}</p>
          <p className="evenement-content">{evenement.libelle}</p>
        </div>
        <div id="back">
          <p className="evenement-head">
            <img
              src={iconLocation}
              alt={iconLocation}
              id="iconLocation"
              loading="lazy"
            />
            {evenement.lieu}
          </p>
          <div className="evenement-content">
            <Button
              label="Voir l'événement"
              variant="secondary"
              onClick={() => {}}></Button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
}

function EvenementSkeleton(): ReactElement {
  return <Skeleton className="evenement-skeleton"></Skeleton>;
}

export {Evenement, EvenementSkeleton};
